import * as React from 'react'
import { useTranslation } from 'react-i18next'
import { FieldInputProps, FormikHelpers, FormikValues } from 'formik'

import SelectInput from '../ui/selectInput'

interface Props {
    label?: string
    options: FormikValues[]
    field: FieldInputProps<string>
    form: FormikHelpers<FormikValues>
    onChangeCallback?: (selectedValue: string, form: FormikHelpers<FormikValues>) => void
    chosenLabel?: React.MutableRefObject<string | null>
}

const SelectField: React.FunctionComponent<Props> = ({
    label,
    options,
    field,
    form,
    onChangeCallback,
    chosenLabel
}: Props) => {
    const [t] = useTranslation()

    const translatedOptions = options.map((option) => ({
        ...option,
        label: t(option.label)
    }))

    return (
        <div className="form__fieldContainer">
            <SelectInput
                form={form}
                label={label}
                field={field}
                options={translatedOptions}
                onChangeCallback={onChangeCallback}
                outerRef={chosenLabel}
            />
        </div>
    )
}

export default SelectField
